<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <base-header
      :title="$t('app.tipo-concepto.name')"
      link="Dashboard"
    />
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-material-card color="primary">
          <template v-slot:heading>
            <v-row>
              <v-col class="flex-grow-1 flex-grow-0">
                <div class="display-2 font-weight-light">
                  {{ $t('app.tipo-concepto.title') }}
                </div>

                <div class="subtitle-1 font-weight-light">
                  {{ $t('app.tipo-concepto.subtitle') }}
                </div>
              </v-col>
              <v-col class="d-flex align-center flex-grow-0 flex-shrink-0">
                <v-btn
                  dark
                  @click="openItemAdd"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-plus-circle
                  </v-icon>

                  {{ $t('app.buttons.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <v-card-title>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="filters.selected.query"
                  :label="$t('app.buttons.search')"
                  rounded
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :search="filters.selected.query"
          >
            <template v-slot:item.actions="{ item }">
              <v-col class="d-flex justify-end">
                <v-btn
                  icon
                  @click="openItemDetail(item)"
                >
                  <v-icon>
                    mdi-eye
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemEdit(item)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemDelete(item)"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <tipo-concepto-add />
    <tipo-concepto-edit />
    <tipo-concepto-detail />
    <tipo-concepto-delete />
  </v-container>
</template>

<script>
  export default {
    name: 'TipoConcepto',
    components: {
      TipoConceptoAdd: () => import('./TipoConceptoAdd'),
      TipoConceptoEdit: () => import('./TipoConceptoEdit'),
      TipoConceptoDetail: () => import('./TipoConceptoDetail'),
      TipoConceptoDelete: () => import('./TipoConceptoDelete'),
    },
    data () {
      return {
        headers: [
          {
            text: this.$t('app.headers.id'),
            value: 'id',
          },
          {
            text: this.$t('app.headers.name'),
            value: 'nombre',
          },
          {
            text: this.$t('app.headers.description'),
            value: 'descripcion',
          },
          {
            text: this.$t('app.deportes.single'),
            value: 'deporte.descripcion',
          },
          {
            text: '',
            value: 'actions',
            sortable: false,
          },
        ],
        items: [],
        filters: {
          data: {
            items: [],
          },
          selected: {
            items: [],
            query: '',
          },
        },
      }
    },
    mounted () {
      this.init()

      EventBus.$on('reload-items', () => {
        this.init()
      })
    },
    methods: {
      async init () {
        this.toggleLoader()

        this.items = await this.getTipoConceptoPago()

        this.toggleLoader()
      },
      openItemAdd () {
        EventBus.$emit('tipo-concepto-add')
      },
      openItemEdit (item) {
        EventBus.$emit('tipo-concepto-edit', item)
      },
      openItemDetail (item) {
        EventBus.$emit('tipo-concepto-detail', item)
      },
      openItemDelete (item) {
        EventBus.$emit('tipo-concepto-delete', item)
      },
    },
  }
</script>

<style scoped>

</style>
